export type Rgb = readonly [number, number, number];

export interface EnvironmentPalette {
  /** Background, 0–1 RGB. */
  bg: Rgb;
  /** Soft interior of organic shapes. */
  fill: Rgb;
  /** Marked contour line. */
  line: Rgb;
  /** Secondary contour accent. */
  accent: Rgb;
}

/** Cima: fundo bege, bolhas escuras. */
export const upperPalette: EnvironmentPalette = {
  bg: [0.93, 0.88, 0.78],
  fill: [0.08, 0.1, 0.2],
  line: [0.02, 0.03, 0.08],
  accent: [0.18, 0.28, 0.42],
};

/** Baixo: fundo marinho, bolhas claras. */
export const lowerPalette: EnvironmentPalette = {
  bg: [0.035, 0.07, 0.16],
  fill: [0.94, 0.9, 0.82],
  line: [0.99, 0.97, 0.92],
  accent: [0.82, 0.78, 0.68],
};

export function rgbToCss(rgb: Rgb, a = 1): string {
  const r = Math.round(rgb[0] * 255);
  const g = Math.round(rgb[1] * 255);
  const b = Math.round(rgb[2] * 255);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function rgbToHex(rgb: Rgb): number {
  const r = Math.round(rgb[0] * 255);
  const g = Math.round(rgb[1] * 255);
  const b = Math.round(rgb[2] * 255);
  return (r << 16) | (g << 8) | b;
}
